module.exports = __webpack_public_path__ + "static/media/pharmacy_education_female_image.96368b69.jpg";